import React, { useState, useEffect } from 'react';
import './journey.css'
import C2wSuperxJourneyCard from '../../../common/C2wSuperxHome/joruney/journeyCard';
import C2wJourneyMobileCard from '../../../common/C2wSuperxHome/joruney/journeyMobileCard';

function C2wSuperxJourney() {

  /**
 * @constant windowWidth
 * @author Vishal Lohbande
 *
 * Description:
 * - Initializes state variable `windowWidth` with the current browser window width (`window.innerWidth`).
 * - Stores the current width of the viewport for responsive UI updates.
 *
 * Usage:
 * - Used to track the width of the browser window inside a React component.
 */
/**
 * @function useEffect Hook for window resize listener
 * @author Vishal Lohbande
 *
 * Description:
 * - Registers an event listener for the window `resize` event when the component mounts.
 * - Defines a handler function `handleResize` that updates the `windowWidth` state with the latest `window.innerWidth`.
 * - Cleans up the event listener when the component unmounts to avoid memory leaks.
 *
 * Usage:
 * - Keeps the React component state synchronized with the browser window size.
 *
 * Notes:
 * - The effect runs only once on mount due to the empty dependency array `[]`.
 * - For better performance, consider throttling or debouncing the resize handler.
 * - In server-side rendering environments, verify that `window` is defined before accessing it.
 */
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);


  const startCrdArr1 = [
    {
      heading: 'Learning & Task Application',
      infoPara : 'Learn key concepts and apply them to small tasks, building the foundation for the project.',
    },
    {
      heading: 'Design & Planning',
      infoPara : 'Create prototypes, write documentation (SRS), plan sprints, and set tasks with mentor supervision.',
    },
    { 
      heading: 'Deployment',
      infoPara : 'Prepare final testing, versioning, and configure cloud setup for application deployment. Verify functionality in the live environment.',
    },
  ]

  const arr1=[1, 3, 5]
  /**
 * @constant renderedStartCrdArr1
 * @author Vishal Lohbande
 *
 * Description:
 * - Maps over the `startCrdArr1` array (if defined).
 * - For each item (`obj`) in `startCrdArr1`, renders a `C2wSuperxJourneyCard` component.
 * - Passes the current object as the `obj` prop.
 * - Passes a corresponding value from `arr1` (by matching the current index) as the `index` prop.
 *
 * Usage:
 * - Used to render a list of journey cards with specific indices from `arr1`.
 *
 * Notes:
 * - Consider adding a unique `key` prop for React list rendering optimization.
 * - Ensure `arr1` length matches or exceeds `startCrdArr1` length to avoid undefined `index` values.
 */
  const renderedStartCrdArr1 = startCrdArr1?.map((obj, index) => {
    return <C2wSuperxJourneyCard obj={obj} index={arr1[index]} />
  })


  const startCrdArr2 = [
    {
      heading: 'Team Formation & Ideation',
      infoPara : 'Form teams, brainstorm ideas, research the market, and define a problem statement.',
    },
    {
      heading: 'Development & Iterative Feedback',
      infoPara : 'Code, integrate systems, and test while receiving feedback to improve the project.',
    },
    {
      heading: 'Presentation & Pitching',
      infoPara : 'Present the final project, build confidence in explaining your work, and pitch to external audiences.',
    },
  ]

  const arr2=[2, 4, 6]
  /**
 * @constant renderedStartCrdArr2
 * @author Vishal Lohbande
 *
 * Description:
 * - Maps over the `startCrdArr2` array if it exists.
 * - For each element `obj` in `startCrdArr2`, renders a `C2wSuperxJourneyCard` component.
 * - Passes the current object as the `obj` prop.
 * - Passes the corresponding value from the `arr2` array (by index) as the `index` prop.
 *
 * Usage:
 * - Used to render a list of journey cards with indices defined by `arr2`.
 *
 * Notes:
 * - It is recommended to add a unique `key` prop for each component to optimize React rendering.
 * - Ensure `arr2` length matches or exceeds `startCrdArr2` length to avoid undefined `index` props.
 */
  const renderedStartCrdArr2 = startCrdArr2?.map((obj, index) => {
    return <C2wSuperxJourneyCard obj={obj} index={arr2[index]} />
  })

  const mobileArr = [
    {
      heading: 'Learning & Task Application',
      infoPara : 'Learn key concepts and apply them to small tasks, building the foundation for the project.',
    },

    {
      heading: 'Team Formation & Ideation',
      infoPara : 'Form teams, brainstorm ideas, research the market, and define a problem statement.',
    },

    {
      heading: 'Design & Planning',
      infoPara : 'Create prototypes, write documentation (SRS), plan sprints, and set tasks with mentor supervision.',
    },

    {
      heading: 'Development & Iterative Feedback',
      infoPara : 'Code, integrate systems, and test while receiving feedback to improve the project.',
    },

    { 
      heading: 'Deployment',
      infoPara : 'Prepare final testing, versioning, and configure cloud setup for application deployment. Verify functionality in the live environment.',
    },
    {
      heading: 'Presentation & Pitching',
      infoPara : 'Present the final project, build confidence in explaining your work, and pitch to external audiences.',
    },
  ]

  /**
 * @constant mobileRenderedArr
 * @author Vishal Lohbande
 *
 * Description:
 * - Maps over the `mobileArr` array if it exists.
 * - For each element `obj` in `mobileArr`, renders a `C2wJourneyMobileCard` component.
 * - Passes the current object as the `obj` prop.
 * - Passes the 1-based index (`index + 1`) as the `index` prop.
 *
 * Usage:
 * - Used to render a list of mobile journey cards with sequential indices starting from 1.
 *
 * Notes:
 * - Adding a unique `key` prop to each rendered component is recommended for React list optimization.
 */
  const mobileRenderedArr = mobileArr?.map((obj, index) => {
    return <C2wJourneyMobileCard obj={obj} index={index + 1 } />
  })

  return (
    windowWidth > 620 ? 
    <div className='C2wSuperxJourney_ctn'>
      <img className='C2wSuperxJourney_png' src='/assets/superx/images/map.png' alt='/'/>
      <img className='C2wSuperxJourney_left_arrow' src='/assets/superx/images/journeyLeftArrow.png' alt='/'/>
      <img className='C2wSuperxJourney_right_arrow' src='/assets/superx/images/journeyRightArrow.png' alt='/'/>
      <div className='C2wSuperxHeading_ctn_hld'>
        <div className='C2wSuperxHeading_ctn'>
          {'Journey of '}
          <span className='C2wSuperxHeadingSpan'>{'Super-x'}</span>
        </div>
        <div className='C2wSuperxJourneySubheading'>
          <span>{'Concept to Completion: '}</span>
          {'teamwork, mentorship, showcase, entrepreneurship'}
        </div>
      </div>
      <div className='C2wSuperxJourney_card_holder'>
        <div className='C2wSuperxJourney_card_start'>
            {renderedStartCrdArr1}         
        </div>
          <img src='/assets/superx/images/journeyMiddleLine.png' />
        <div className='C2wSuperxJourney_card_end'>
          {renderedStartCrdArr2}         
        </div>
      </div>
    </div>
    : 
    <div className='C2wSuperxJourney_ctn'>
      <div className='C2wSuperxHeading_ctn_hld'>
        <div className='C2wSuperxHeading_ctn'>
          {'Journey of '}
          <span className='C2wSuperxHeadingSpan'>{'Super-x'}</span>
        </div>
        <div className='C2wSuperxJourneySubheading'>
          <span>{'Concept to Completion: '}</span>
          {'teamwork, mentorship, showcase, entrepreneurship'}
        </div>
      </div>
      <div className='C2wSuperxJourney_card_holder'>
        <img src='/assets/superx/images/MobileLineJourney.png' alt='mobile-journey-' />
        <div className='C2wSuperxJourney_card_mobile'>
          {mobileRenderedArr}
          </div>
    </div>
    </div>
  )
}

export default C2wSuperxJourney;
